module.exports = require('./helpers/bundle-url').getBundleURL('bVcOE') + "logo-dark.eefe0b7f.svg";